import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import { ManagePaths } from '../constants/routes';
export const getAiSettingsUrl = () => `${getFullUrl('app')}/ai-settings/${PortalIdParser.get()}`;
export const getBaseUrl = () => '/breeze-studio';
export const getRootUrl = () => `${getBaseUrl()}/${PortalIdParser.get()}`;
export const getSettingsUrl = () => `/settings/${PortalIdParser.get()}/account-defaults/general`;
export const redirectToMainSettings = () => {
  window.location.href = `${getFullUrl('app')}${getSettingsUrl()}`;
};
const getInboxSearch = ({
  agentInstanceId,
  executionId
}) => {
  const searchParams = new URLSearchParams();
  searchParams.set('agentInstanceId', String(agentInstanceId));
  if (executionId !== null && executionId !== void 0 && executionId.trim()) {
    searchParams.set('executionId', executionId);
  }
  const searchString = searchParams.toString();
  return searchString ? `?${searchString}` : '';
};
export const getInboxRoute = params => `${ManagePaths.INBOX}${getInboxSearch(params)}`;
export const getInboxUrl = params => `${getFullUrl('app')}${getRootUrl()}${getInboxRoute(params)}`;
export const getMarketplaceUrl = () => `${getFullUrl('app')}/marketplace/${PortalIdParser.get()}`;
export const getAgentMarketplaceUrl = referrer => `${getMarketplaceUrl()}/explore?eco_PRODUCT_TYPE=AGENT&eco_AGENT_TYPE=STUDIO${referrer ? `&referrer=${referrer}` : ''}`;
export const getAssistantMarketplaceUrl = referrer => `${getMarketplaceUrl()}/explore?eco_PRODUCT_TYPE=AGENT&eco_AGENT_TYPE=ASSISTANT${referrer ? `&referrer=${referrer}` : ''}`;
export const getMarketplaceListingUrl = (listingSlug, referrer = 'breeze') => `${getMarketplaceUrl()}/listing/${listingSlug}${referrer ? `?referrer=${referrer}` : ''}`;
export const getConnectedAppsUrl = () => `${getFullUrl('app')}/connected-apps/${PortalIdParser.get()}/installed`;
export const getUserUrl = userId => `${getFullUrl('app')}/settings/${PortalIdParser.get()}/users/user/${userId}`;